<script src="../../../assets/js/script.js"></script>
<div class="wrapper">
  <div class="container-fluid">

    <div class="progressbar">
      <div class="progress" id="progress"></div>

      <div class="progress-step progress-step-active" data-title="Merchant"></div>
      <div class="progress-step" data-title="Merchant's contact details"></div>
      <div class="progress-step" data-title="Terminal onboarding"></div>
      <div class="progress-step" data-title="Review"></div>
    </div>

    <div class="row">
      <div class="col-sm-12">

        <div class="card-box">
          <h4 class="header-title">Merchant sign up</h4>
          <p class="sub-header"></p>

          <div class="row">
            <div class="form-group" *ngIf="hasError" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert type="danger" [dismissible]="false" style="width:100%;">
                  <strong>Error! </strong> {{message}}
                </ngb-alert>
              </div>
            </div>
          </div>

          <div class="row form-horizontal form-step form-step-active">
            <div class="col-md-12 form-horizontal px-3">
              <signup-merchant-component (onErrorMessage)="formHasError($event)"></signup-merchant-component>
            </div>
          </div>

          <div class="row form-horizontal form-step">
            <div class="col-md-12 form-horizontal px-3">
              <signup-contact-component (onErrorMessage)="formHasError($event)"></signup-contact-component>
            </div>
          </div>

          <div class="row form-horizontal form-step">
            <div class="col-md-12 form-horizontal px-3">
              <signup-terminal-component (onErrorMessage)="formHasError($event)"></signup-terminal-component>
            </div>
          </div>

          <div class="row  form-horizonta form-step">
            <div class="col-md-12 form-horizontal px-3">
             <signup-summary-component></signup-summary-component>
            </div>
          </div>

          <div class="row col-md-12 form-horizontal">

            <div class="row col-md-6">
              <div class="col-md-4">
                <button *ngIf="steps > 0" (click)="prev()" class="btn btn-info float-left" style="width: 76px; padding-right: 10px; ">Previous</button>
                <button *ngIf="steps < 3" (click)="next()" class="btn btn-info float-left" style=" width: 76px; margin-left: 10px;">Next</button>
                <button *ngIf="steps ===3" (click)="save()" class="btn btn-info float-left" style=" width: 76px; margin-left: 10px;">Save</button>
              </div>
            </div>

            <div class="col-md-6">
              <div class="row">
                <ngb-alert *ngIf="redirect" type="info" [dismissible]="false" style="width:100%;">
                  <strong>Redirecting in : {{ remainingCount$ | async }} </strong>
                </ngb-alert>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>
